import React from 'react'

function Loader() {
    return (
        <>
            <div className="text-center mmm">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </>
    )
}

export default Loader